"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapOtpChannel = void 0;
const mapOtpChannel = (getOtpChannelResponse) => getOtpChannelResponse.channels[0];
exports.mapOtpChannel = mapOtpChannel;
//# sourceMappingURL=mapper.js.map